export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-I-74b7f07fe8547dfd9b0d10e7ade263ae.jpg";